import { render, staticRenderFns } from "./foto.vue?vue&type=template&id=6b0e3866"
import script from "./foto.vue?vue&type=script&lang=js"
export * from "./foto.vue?vue&type=script&lang=js"
import style0 from "./foto.vue?vue&type=style&index=0&id=6b0e3866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports